module.exports = __webpack_public_path__ + "static/media/cq_esporta_exel.d3f8fc41.svg";